export const profile = {
  en: {
    title: 'Profile',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    quizHistory: 'Quiz History',
    editAvatar: 'Edit Avatar',
    editName: 'Edit Name',
    usernamePlaceholder: 'Username',
    xp: 'Questions',
    level: 'Journey',
    streak: 'Days',
    favoriteVerses: 'Favorite Verses',
    exampleVerse: '1 CORINTHIANS 13:4',
    loading: 'Loading...',
    fetchingStats: 'Fetching your stats and achievements',
    saving: 'Saving...',
    saved: 'Saved!',
    error: 'Error',
    failedUpdate: 'Failed to update profile.',
    failedSignOut: 'Failed to sign out.',
    tapToSetName: 'Tap to set name',
    tapToEdit: 'Tap to edit',
    joinCommunity: 'Join Community',
    inviteFriends: 'Invite Friends',
    progressSummary: 'Your recent study progress',
    questionsAnsweredSummary: '{{answered}} correct out of {{total}} answered',
    bestScoreSummary: 'Best score: {{score}}',
    noProgressYet: 'Finish a quiz to start building your journey history.',
  },
  es: {
    title: 'Perfil',
    edit: 'Editar',
    save: 'Guardar',
    cancel: 'Cancelar',
    quizHistory: 'Historial de cuestionarios',
    editAvatar: 'Editar avatar',
    editName: 'Editar nombre',
    usernamePlaceholder: 'Nombre de usuario',
    xp: 'Preguntas',
    level: 'Camino',
    streak: 'Dias',
    favoriteVerses: 'Versículos favoritos',
    exampleVerse: '1 CORINTIOS 13:4',
    loading: 'Cargando...',
    fetchingStats: 'Obteniendo tus estadísticas y logros',
    saving: 'Guardando...',
    saved: '¡Guardado!',
    error: 'Error',
    failedUpdate: 'Error al actualizar el perfil.',
    failedSignOut: 'Error al cerrar sesión.',
    tapToSetName: 'Toca para establecer nombre',
    tapToEdit: 'Toca para editar',
    joinCommunity: 'Unirse a la Comunidad',
    inviteFriends: 'Invitar Amigos',
    progressSummary: 'Tu progreso reciente de estudio',
    questionsAnsweredSummary: '{{answered}} correctas de {{total}} respondidas',
    bestScoreSummary: 'Mejor puntuación: {{score}}',
    noProgressYet: 'Termina un quiz para comenzar tu historial de progreso.',
  },
  fr: {
    title: 'Profil',
    edit: 'Modifier',
    save: 'Enregistrer',
    cancel: 'Annuler',
    quizHistory: 'Historique des quiz',
    editAvatar: 'Modifier l\'avatar',
    editName: 'Modifier le nom',
    usernamePlaceholder: 'Nom d\'utilisateur',
    xp: 'Questions',
    level: 'Parcours',
    streak: 'Jours',
    favoriteVerses: 'Versets favoris',
    exampleVerse: '1 CORINTHIENS 13:4',
    loading: 'Chargement...',
    fetchingStats: 'Récupération de vos statistiques et réalisations',
    saving: 'Enregistrement...',
    saved: 'Enregistré!',
    error: 'Erreur',
    failedUpdate: 'Échec de la mise à jour du profil.',
    failedSignOut: 'Échec de la déconnexion.',
    tapToSetName: 'Appuyez pour définir le nom',
    tapToEdit: 'Appuyez pour modifier',
    joinCommunity: 'Rejoindre la Communauté',
    inviteFriends: 'Inviter des Amis',
    progressSummary: 'Votre progression d’étude récente',
    questionsAnsweredSummary: '{{answered}} bonnes réponses sur {{total}}',
    bestScoreSummary: 'Meilleur score : {{score}}',
    noProgressYet: 'Terminez un quiz pour commencer votre historique.',
  },
  de: {
    title: 'Profil',
    edit: 'Bearbeiten',
    save: 'Speichern',
    cancel: 'Abbrechen',
    quizHistory: 'Quiz-Verlauf',
    editAvatar: 'Avatar bearbeiten',
    editName: 'Name bearbeiten',
    usernamePlaceholder: 'Benutzername',
    xp: 'Fragen',
    level: 'Reise',
    streak: 'Tage',
    favoriteVerses: 'Lieblings-Verse',
    exampleVerse: '1 KORINTHER 13:4',
    loading: 'Laden...',
    fetchingStats: 'Lade deine Statistiken und Erfolge',
    saving: 'Speichern...',
    saved: 'Gespeichert!',
    error: 'Fehler',
    failedUpdate: 'Profil konnte nicht aktualisiert werden.',
    failedSignOut: 'Abmeldung fehlgeschlagen.',
    tapToSetName: 'Tippen, um Namen festzulegen',
    tapToEdit: 'Tippen zum Bearbeiten',
    joinCommunity: 'Community beitreten',
    inviteFriends: 'Freunde einladen',
    progressSummary: 'Dein letzter Lernfortschritt',
    questionsAnsweredSummary: '{{answered}} richtig von {{total}} beantwortet',
    bestScoreSummary: 'Beste Punktzahl: {{score}}',
    noProgressYet: 'Beende ein Quiz, um deinen Verlauf aufzubauen.',
  },
  pt: {
    title: 'Perfil',
    edit: 'Editar',
    save: 'Salvar',
    cancel: 'Cancelar',
    quizHistory: 'Histórico de Quiz',
    editAvatar: 'Editar Avatar',
    editName: 'Editar Nome',
    usernamePlaceholder: 'Nome de usuário',
    xp: 'Perguntas',
    level: 'Jornada',
    streak: 'Dias',
    favoriteVerses: 'Versículos Favoritos',
    exampleVerse: '1 CORÍNTIOS 13:4',
    loading: 'Carregando...',
    fetchingStats: 'Buscando suas estatísticas e conquistas',
    saving: 'Salvando...',
    saved: 'Salvo!',
    error: 'Erro',
    failedUpdate: 'Falha ao atualizar perfil.',
    failedSignOut: 'Falha ao sair.',
    tapToSetName: 'Toque para definir nome',
    tapToEdit: 'Toque para editar',
    joinCommunity: 'Entrar na Comunidade',
    inviteFriends: 'Convidar Amigos',
    progressSummary: 'Seu progresso recente de estudo',
    questionsAnsweredSummary: '{{answered}} corretas de {{total}} respondidas',
    bestScoreSummary: 'Melhor pontuação: {{score}}',
    noProgressYet: 'Conclua um quiz para começar seu histórico de jornada.',
  },
  ru: {
    title: 'Профиль',
    edit: 'Редактировать',
    save: 'Сохранить',
    cancel: 'Отмена',
    quizHistory: 'История викторин',
    editAvatar: 'Редактировать аватар',
    editName: 'Редактировать имя',
    usernamePlaceholder: 'Имя пользователя',
    xp: 'Вопросы',
    level: 'Путь',
    streak: 'Дни',
    favoriteVerses: 'Любимые стихи',
    exampleVerse: '1 КОРИНФЯНАМ 13:4',
    loading: 'Загрузка...',
    fetchingStats: 'Получение ваших статистик и достижений',
    saving: 'Сохранение...',
    saved: 'Сохранено!',
    error: 'Ошибка',
    failedUpdate: 'Не удалось обновить профиль.',
    failedSignOut: 'Не удалось выйти.',
    tapToSetName: 'Нажмите, чтобы задать имя',
    tapToEdit: 'Нажмите для редактирования',
    joinCommunity: 'Присоединиться к Сообществу',
    inviteFriends: 'Пригласить Друзей',
    progressSummary: 'Ваш недавний прогресс в изучении',
    questionsAnsweredSummary: '{{answered}} правильных из {{total}}',
    bestScoreSummary: 'Лучший результат: {{score}}',
    noProgressYet: 'Завершите викторину, чтобы начать историю прогресса.',
  },
  tl: {
    title: 'Profile',
    edit: 'I-edit',
    save: 'I-save',
    cancel: 'Kanselahin',
    quizHistory: 'Kasaysayan ng Quiz',
    editAvatar: 'I-edit ang Avatar',
    editName: 'I-edit ang Pangalan',
    usernamePlaceholder: 'Username',
    xp: 'Tanong',
    level: 'Paglalakbay',
    streak: 'Araw',
    favoriteVerses: 'Paboritong Talata',
    exampleVerse: '1 CORINTO 13:4',
    loading: 'Naglo-load...',
    fetchingStats: 'Kinukuha ang inyong mga stats at achievements',
    saving: 'Nise-save...',
    saved: 'Na-save na!',
    error: 'Error',
    failedUpdate: 'Hindi ma-update ang profile.',
    failedSignOut: 'Hindi ma-sign out.',
    tapToSetName: 'I-tap para maglagay ng pangalan',
    tapToEdit: 'I-tap para i-edit',
    joinCommunity: 'Sumali sa Komunidad',
    inviteFriends: 'Mag-imbita ng mga Kaibigan',
    progressSummary: 'Ang inyong kamakailang pag-unlad',
    questionsAnsweredSummary: '{{answered}} tama sa {{total}} na nasagutan',
    bestScoreSummary: 'Pinakamataas na puntos: {{score}}',
    noProgressYet: 'Tapusin ang quiz para mabuo ang inyong history.',
  },
  it: {
    title: 'Profilo',
    edit: 'Modifica',
    save: 'Salva',
    cancel: 'Annulla',
    quizHistory: 'Cronologia Quiz',
    editAvatar: 'Modifica Avatar',
    editName: 'Modifica Nome',
    usernamePlaceholder: 'Nome utente',
    xp: 'Domande',
    level: 'Percorso',
    streak: 'Giorni',
    favoriteVerses: 'Versetti Preferiti',
    exampleVerse: '1 CORINZI 13:4',
    loading: 'Caricamento...',
    fetchingStats: 'Recupero delle tue statistiche e traguardi',
    saving: 'Salvataggio...',
    saved: 'Salvato!',
    error: 'Errore',
    failedUpdate: 'Impossibile aggiornare il profilo.',
    failedSignOut: 'Impossibile disconnettersi.',
    tapToSetName: 'Tocca per impostare il nome',
    tapToEdit: 'Tocca per modificare',
    joinCommunity: 'Unisciti alla Comunità',
    inviteFriends: 'Invita Amici',
    progressSummary: 'I tuoi progressi recenti di studio',
    questionsAnsweredSummary: '{{answered}} corrette su {{total}} risposte',
    bestScoreSummary: 'Punteggio migliore: {{score}}',
    noProgressYet: 'Completa un quiz per iniziare la tua cronologia.',
  },
  am: {
    title: 'መገለጫ',
    edit: 'አርትዕ',
    save: 'አስቀምጥ',
    cancel: 'ሰርዝ',
    quizHistory: 'የጥያቄ ታሪክ',
    editAvatar: 'አቫታር አርትዕ',
    editName: 'ስም አርትዕ',
    usernamePlaceholder: 'የተጠቃሚ ስም',
    xp: 'ጥያቄዎች',
    level: 'ጉዞ',
    streak: 'ቀናት',
    favoriteVerses: 'የተወደዱ ጥቅሶች',
    exampleVerse: '1 ቆሮንቶስ 13:4',
    loading: 'በመጫን ላይ...',
    fetchingStats: 'የእርስዎን ስታቲስቲክስ እና ስኬቶች በመውሰድ ላይ',
    saving: 'በማስቀመጥ ላይ...',
    saved: 'ተቀምጧል!',
    error: 'ስህተት',
    failedUpdate: 'መገለጫን ማዘመን አልተቻለም።',
    failedSignOut: 'መውጣት አልተቻለም።',
    tapToSetName: 'ስም ለማስቀመጥ ይንኩ',
    tapToEdit: 'ለማርትዕ ይንኩ',
    joinCommunity: 'ማህበረሰብ ይቀላቀሉ',
    inviteFriends: 'ጓደኞችን ይጋብዙ',
    progressSummary: 'የቅርብ ጊዜ የጥናት እድገትዎ',
    questionsAnsweredSummary: '{{total}} ውስጥ {{answered}} ትክክል',
    bestScoreSummary: 'ከፍተኛ ውጤት: {{score}}',
    noProgressYet: 'የጉዞ ታሪክዎን ለመጀመር ጥያቄ ያጠናቅቁ።',
  },
  ko: {
    title: '프로필',
    edit: '편집',
    save: '저장',
    cancel: '취소',
    quizHistory: '퀴즈 기록',
    editAvatar: '아바타 편집',
    editName: '이름 편집',
    usernamePlaceholder: '사용자명',
    xp: '질문',
    level: '여정',
    streak: '일수',
    favoriteVerses: '좋아하는 구절',
    exampleVerse: '고린도전서 13:4',
    loading: '로딩 중...',
    fetchingStats: '통계와 업적을 가져오는 중',
    saving: '저장 중...',
    saved: '저장됨!',
    error: '오류',
    failedUpdate: '프로필 업데이트에 실패했습니다.',
    failedSignOut: '로그아웃에 실패했습니다.',
    tapToSetName: '이름을 설정하려면 탭하세요',
    tapToEdit: '편집하려면 탭하세요',
    joinCommunity: '커뮤니티 참여',
    inviteFriends: '친구 초대',
    progressSummary: '최근 학습 진행 상황',
    questionsAnsweredSummary: '{{total}}문제 중 {{answered}}문제 정답',
    bestScoreSummary: '최고 점수: {{score}}',
    noProgressYet: '여정 기록을 시작하려면 퀴즈를 완료하세요.',
  },
};
